export default __webpack_public_path__ + "static/media/p4-2.e2ba37be.png";